<template>
  <div>
    <SidebarSearch
      ref="sidebarSearch"
      @submit="submitForm"
      @clear="clearForm"
    >
      <SearchCollapse
        :expanded="true"
        title="Filtros de Mapeamento"
      >
        <div class="form-group">
          <label>Quadro:</label>
          <NxSelectQuadro
            :onlyActive="true"
            @update:value="handleSelectUpdate('quadroId', $event)"
          />
        </div>
        <div class="form-group" v-if="form.quadroId">
          <label>Coluna:</label>
          <NxSelectQuadroColuna
            :boardId="form.quadroId"
            :onlyActive="true"
            @update:value="handleSelectUpdate('colunaId', $event)"
          />
        </div>
        <div class="form-group">
          <label>Tag:</label>
          <NxSelectTag
            :onlyActive="true"
            @update:value="handleSelectUpdate('tagId', $event)"
          />
        </div>
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import NxSelectQuadro from '@/components/nexum/components/custom-selects/NxSelectQuadro.vue'
import NxSelectQuadroColuna from '@/components/nexum/components/custom-selects/NxSelectQuadroColuna.vue'
import NxSelectTag from '@/components/nexum/components/custom-selects/NxSelectTag.vue'

export default {
  name: 'SidebarTagAssign',
  components: {
    SidebarSearch,
    SearchCollapse,
    NxSelectQuadro,
    NxSelectQuadroColuna,
    NxSelectTag
  },
  data () {
    return {
      form: {
        quadroId: null,
        colunaId: null,
        tagId: null
      }
    }
  },
  methods: {
    submitForm () {
      this.$emit('search', this.form)
    },
    clearForm () {
      // Limpa o formulário
      this.form.quadroId = null
      this.form.colunaId = null
      this.form.tagId = null

      // Emite evento global para limpar selects se necessário
      this.$root.$emit('clearForm')

      // Aguarda o próximo tick para garantir que os componentes reagiram
      this.$nextTick(() => {
        // Envia null explicitamente para indicar limpeza de filtros
        this.$emit('search', null)
      })
    },
    handleSelectUpdate (fieldName, selectedValue) {
      if (selectedValue) {
        this.form[fieldName] = typeof selectedValue === 'object' && selectedValue.hasOwnProperty('value')
          ? selectedValue.value
          : selectedValue

        // Se mudou o quadro, limpa a coluna
        if (fieldName === 'quadroId') {
          this.form.colunaId = null
        }
      } else {
        this.form[fieldName] = null
        // Se limpou o quadro, limpa também a coluna
        if (fieldName === 'quadroId') {
          this.form.colunaId = null
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/board/tag/search/SidebarTagAssign.vue